export default function DownloadIcon(props) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.66699 10.0008L10.0003 13.3342M10.0003 13.3342L13.3337 10.0008M10.0003 13.3342V5.66749C10.0003 4.50857 10.0003 3.92911 9.54156 3.28032C9.23675 2.84926 8.35914 2.31722 7.83597 2.24634C7.04857 2.13966 6.74955 2.29564 6.15152 2.60761C3.48644 3.99785 1.66699 6.78686 1.66699 10.0008C1.66699 14.6032 5.39795 18.3342 10.0003 18.3342C14.6027 18.3342 18.3337 14.6032 18.3337 10.0008C18.3337 6.91631 16.6578 4.22322 14.167 2.78234"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
